export default function Trash({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3.5C10.1716 3.5 9.5 4.17157 9.5 5H7C6.44772 5 6 5.44772 6 6V7H18V6C18 5.44772 17.5523 5 17 5H14.5C14.5 4.17157 13.8284 3.5 13 3.5H11ZM11 4.5C10.7239 4.5 10.5 4.72386 10.5 5H13.5C13.5 4.72386 13.2761 4.5 13 4.5H11Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.04141 8.53835C6.01907 8.24795 6.24868 8 6.53994 8H17.4601C17.7513 8 17.9809 8.24795 17.9586 8.53835L17.0355 19.5383C17.0155 19.7988 16.7983 20 16.537 20H7.46302C7.20175 20 6.98453 19.7988 6.96449 19.5383L6.04141 8.53835ZM8.5 18V10H9.5V18H8.5ZM10.5 18V10H11.5V18H10.5ZM12.5 10V18H13.5V10H12.5ZM14.5 18V10H15.5V18H14.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
